module.exports = __webpack_public_path__ + "img/20.51e9c2c3.png";